<script setup>
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";
import http from "@/service/http";
import {urls} from "@/service/urls";
import cookies from "@/service/cookies";

const props = defineProps(['mini_mobile'])
const { t, locale } = useI18n()
const cookieLanguage = cookies.getLocale()

const locales = [
  {id: 1, label: 'O\'zbekcha', shortLabel: 'O\'Z', value: 'uz'},
  {id: 2, label: 'Ўзбекча', shortLabel: 'ЎЗ', value: 'uk'},
  {id: 3, label: 'Русский', shortLabel: 'РУ', value: 'ru'},
  {id: 4, label: 'English', shortLabel: 'EN', value: 'en'},
]

const changeLocale = (value) => {
  http.post(urls.lang + '/' + value.toLowerCase())
      .then(response => {
        locale.value = value
        cookies.setLocale(value)
        window.location.reload()
      }).catch(e => {
  }).finally(() => {
  })
}


</script>

<template>
  <el-dropdown class="localization" trigger="click">
    <el-button size="large" type="primary" plain>
      <i class="fa-light fa-globe"></i>
      {{ locales.find(item => item.value === locale).shortLabel }}
      <i class="fa-solid fa-sort-down" style="margin-bottom: 5px"></i>
    </el-button>
    <template #dropdown>
      <el-dropdown-menu>
        <div v-for="lang in locales" :key="lang.id" @click="changeLocale(lang.value)">
          <el-dropdown-item :class="locale === lang.value ? 'locale-active' : ''" style="padding: 0 24px">
            {{ lang.label }}
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<style scoped lang="scss">

</style>
